import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
}

.access-shell {
  background: #f7f6fb;
}

.access-visual {
  background: radial-gradient(circle at 14% 16%, rgba(255, 255, 255, 0.78) 0, rgba(255, 255, 255, 0) 30%), radial-gradient(circle at 88% 84%, rgba(255, 234, 220, 0.9) 0, rgba(255, 234, 220, 0) 34%), linear-gradient(145deg, #dedaff 0%, #dce9ff 50%, #ffe9dd 100%);
}

.access-visual::before,
.access-visual::after {
  position: absolute;
  content: "";
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  pointer-events: none;
}

.access-visual::before {
  top: -88px;
  right: -76px;
  width: 280px;
  height: 280px;
  box-shadow: 0 0 0 56px rgba(255, 255, 255, 0.14);
}

.access-visual::after {
  bottom: -120px;
  left: -92px;
  width: 320px;
  height: 320px;
  box-shadow: 0 0 0 72px rgba(115, 110, 183, 0.06);
}

.access-main {
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at 92% 10%, rgba(222, 218, 255, 0.72) 0, rgba(222, 218, 255, 0) 28%), radial-gradient(circle at 6% 92%, rgba(255, 226, 207, 0.64) 0, rgba(255, 226, 207, 0) 30%), #faf9fc;
}

.access-card {
  position: relative;
  z-index: 1;
  box-shadow: 0 26px 70px rgba(53, 47, 96, 0.12), 0 3px 12px rgba(53, 47, 96, 0.05);
}

button,
input {
  -webkit-tap-highlight-color: transparent;
}

input::-ms-reveal,
input::-ms-clear {
  display: none;
}`],
})
export class PageAccessComponent implements OnInit {
    public mode: string = 'login';
    public signupStep: number = 1;
    public busy: boolean = false;
    public showPassword: boolean = false;

    public loginData: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        email: '',
        code: '',
        name: '',
        password: '',
        password_confirm: '',
        agree_terms: false,
        agree_privacy: false
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const check = await this.service.auth.check();
        if (check) location.href = '/';
    }

    public errorMessage(data: any, fallback: string) {
        if (data && data.message) return data.message;
        if (typeof data === 'string') return data;
        return fallback;
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: status === 'success' ? '완료' : '확인해주세요',
            message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status
        });
    }

    public async switchMode(mode: string) {
        this.mode = mode;
        this.signupStep = 1;
        await this.service.render();
    }

    public async togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
        await this.service.render();
    }

    public async editSignupEmail() {
        this.signupStep = 1;
        this.signupData.code = '';
        await this.service.render();
    }

    public async login() {
        if (!this.loginData.email || !this.loginData.password) {
            await this.alert('이메일(또는 아이디)과 비밀번호를 입력해주세요.');
            return;
        }
        this.busy = true;
        await this.service.render();
        const { code, data } = await wiz.call('login', this.loginData);
        this.busy = false;
        if (code === 200) {
            location.href = '/dashboard';
            return;
        }
        await this.alert(this.errorMessage(data, '로그인에 실패했습니다.'));
        await this.service.render();
    }

    public async sendCode() {
        if (!this.signupData.email) {
            await this.alert('이메일을 입력해주세요.');
            return;
        }
        this.busy = true;
        await this.service.render();
        const { code, data } = await wiz.call('send_code', {
            email: this.signupData.email
        });
        this.busy = false;
        if (code === 200) {
            this.signupStep = 2;
            await this.alert('인증번호를 전송했습니다. 메일함을 확인해주세요.', 'success');
        } else {
            await this.alert(this.errorMessage(data, '인증 메일을 보내지 못했습니다.'));
        }
        await this.service.render();
    }

    public async verifyCode() {
        if (!this.signupData.code || this.signupData.code.length !== 6) {
            await this.alert('6자리 인증번호를 입력해주세요.');
            return;
        }
        this.busy = true;
        await this.service.render();
        const { code, data } = await wiz.call('verify_code', {
            email: this.signupData.email,
            code: this.signupData.code
        });
        this.busy = false;
        if (code === 200) {
            this.signupStep = 3;
            await this.alert('이메일 인증이 완료되었습니다.', 'success');
        } else {
            await this.alert(this.errorMessage(data, '인증번호를 확인해주세요.'));
        }
        await this.service.render();
    }

    public async register() {
        if (!this.signupData.name) {
            await this.alert('이름을 입력해주세요.');
            return;
        }
        if (!this.signupData.password || this.signupData.password.length < 8) {
            await this.alert('비밀번호는 8자 이상 입력해주세요.');
            return;
        }
        if (this.signupData.password !== this.signupData.password_confirm) {
            await this.alert('비밀번호 확인이 일치하지 않습니다.');
            return;
        }
        if (!this.signupData.agree_terms || !this.signupData.agree_privacy) {
            await this.alert('필수 약관에 동의해주세요.');
            return;
        }

        this.busy = true;
        await this.service.render();
        const payload = { ...this.signupData };
        delete payload.code;
        delete payload.password_confirm;
        const { code, data } = await wiz.call('register', {
            data: JSON.stringify(payload)
        });
        this.busy = false;
        if (code === 200) {
            location.href = '/dashboard';
            return;
        }
        await this.alert(this.errorMessage(data, '회원가입을 완료하지 못했습니다.'));
        await this.service.render();
    }
}

export default PageAccessComponent;